import { DOMAIN } from './envValue'

export const spotBasicDomain = DOMAIN
export const spotRoute = '/v2/Tourism/ScenicSpot'

export const allSpotRoute = '/scenicSpot'
export const citySpotRoute = '/scenicSpot/:city'
export const allCityRoute = '/cities'

export const googleMapPlaceRoute = 'https://www.google.com/maps/search/?api=1'
